<template>
  <div id="addproduct">
    <div class="row mlr0 mt30">
      <div class="col-xs-6 prl30">
        <p class="sub-title mb0 mt0 lh25">ADD A PRODUCT</p>
      </div>
      <div class="col-xs-6 text-right prl30">
        <div class="row lh25">
          <div class="pull-right">
            <span class="font20 black click" @click="$router.go(-1)">✕</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content middle add-product" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 mb10">
              <a href="#" @click="newArtwork">
                <span class="iconfont2 icon-g7 button-icon mr20"></span>
                <span class="font16 black text-middle">CREATE NEW ARTWORK</span>
              </a>
            </div>
            <div class="col-xs-7">
              <div class="row">
                <div class="col-xs-12">
                  <el-input
                    suffix-icon="el-icon-search"
                    placeholder="Find an Artwork"
                    v-model="artwork_query"
                    class="mb20"
                  ></el-input>
                  <div
                    class="scroll-wrapper infinite-list-wrapper"
                    style="overflow: auto !important"
                  >
                    <table class="table table-hover">
                      <tr>
                        <th class="w25">
                          <a
                            :class="{
                              active: sortKey == 'name',
                              desc: reverseSort,
                              sort: true,
                            }"
                            @click="sort_by('name')"
                            >Name</a
                          >
                        </th>
                        <th>
                          <a
                            :class="{
                              active: sortKey == 'product',
                              desc: reverseSort,
                              sort: true,
                            }"
                            @click="sort_by('product')"
                            >Product</a
                          >
                        </th>
                        <th class="w15">
                          <a
                            :class="{
                              active: sortKey == 'protocol',
                              desc: reverseSort,
                              sort: true,
                            }"
                            @click="sort_by('protocol')"
                            >Protocol</a
                          >
                        </th>
                        <th class="text-right w20">
                          <a
                            :class="{
                              active: sortKey == 'modified_at',
                              desc: reverseSort,
                              sort: true,
                            }"
                            @click="sort_by('modified_at')"
                            >Last Update</a
                          >
                        </th>
                      </tr>
                      <tbody>
                        <tr
                          :class="activeClass == i._id ? 'active' : ''"
                          v-for="(i, index) in displayedArtwork"
                          @click="selectArtwork(i._id)"
                          :key="index"
                        >
                          <td class="w25">{{ i.name }}</td>
                          <td>{{ i.product }}</td>
                          <td class="w15">{{ i.protocol }}</td>
                          <td class="text-right w20">
                            {{
                              new Date(i.modified_at) | dateFormat("DD.MM.YYYY")
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <nav class="text-center" v-if="pages.length > 0">
                      <ul class="pagination">
                        <li v-if="page != 1" @click="page--">
                          <a aria-label="Previous">
                            <span
                              aria-hidden="true"
                              class="iconfont3 icon-back font11"
                            ></span>
                          </a>
                        </li>
                        <li
                          v-for="(pageNumber, index) in pages.slice(
                            page - 1,
                            page + 5
                          )"
                          @click="page = pageNumber"
                          :key="index"
                        >
                          <a :class="{ active: pageNumber == page }">{{
                            pageNumber
                          }}</a>
                        </li>
                        <li @click="page++" v-if="page < pages.length">
                          <a aria-label="Next">
                            <span
                              aria-hidden="true"
                              class="iconfont3 icon-next font11"
                            ></span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-5 text-center" v-if="artwork">
              <div style="height: 290px; line-height: 290px">
                <img :src="checkImg(artwork.img)" class="artwork_preview" alt />
              </div>
              <div class="mt20" v-if="!isArtworkObsolete()">
                <div class="col-xs-6 text-center">
                  <el-input
                    size="medium"
                    placeholder
                    v-model="product.quantity"
                  ></el-input
                  >Quantity
                </div>
                <div class="col-xs-6 text-center">
                  <div
                    class="click button-select w100"
                    @click="createProduct()"
                  >
                    Add to this project
                  </div>
                </div>
              </div>
              <div class="mt20" v-else>
                <artwork-obsolete-message />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";
import isArtworkObsolete from "../mixins/isArtworkObsoleteMixin"
import ArtworkObsoleteMessage from '@/components/sections/ArtworkObsoleteMessage'

export default {
  name: "addproduct",
  mixins: [isArtworkObsolete],
  components: {
    ArtworkObsoleteMessage
  },
  data() {
    return {
      artworkList: [],
      artwork: {},
      artwork_query: "",
      activeClass: 0,
      product: {
        quantity: 1,
        artwork: {},
        rid: null
      },
      loading: false,
      sortKey: "modified_at",
      reverseSort: true,
      page: 1,
      pages: [],
      perPage: 5,
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    sort_by(sortKey) {
      this.reverseSort = this.sortKey == sortKey ? !this.reverseSort : false;
      this.sortKey = sortKey;
    },
    set_pages(items) {
      this.page = 1;
      this.pages = [];
      let numberOfPages = Math.ceil(items.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(items) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return items.slice(from, to);
    },
    sortArrayOfObjects(arr, column, reverse) {
      arr.sort((a, b) => {
        var textA, textB;
        if (column == "modified_at") {
          textA = new Date(a[column]);
          textB = new Date(b[column]);
        } else {
          textA = a[column].toUpperCase();
          textB = b[column].toUpperCase();
        }
        if (!reverse) {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA < textB ? 1 : textA > textB ? -1 : 0;
        }
      });
      return arr;
    },
    newArtwork() {
      this.$store.state.newArtworkToProductId = this.$route.params.rid;
      this.$router.push({ path: "/collection" });
    },
    productText(item) {
      if (Object.keys(item).length == 0) {
        return;
      }
      var left = "";
      var right = "";
      if (item.layout == "M1" ) {
        left = ", " + item.layout;
      } else {
        left = ", " + item.layout.substring(1) + " Buttons";
      }
      if (item.format == "double") {
        if (item.rightLayout == "M1") {
          right = ", " + item.rightLayout;
        } else {
          right = ", " + item.rightLayout.substring(1) + " Buttons";
        }
      }
      return (
        item.type.toUpperCase() +
        " " +
        item.format.charAt(0).toUpperCase() +
        item.format.slice(1) +
        left +
        right
      );
    },
    finishText(item) {
      if (Object.keys(item).length == 0) {
        return;
      }
      var str = item.frameColor;
      var sL = str.length;
      var i = 0;
      var returnS = "";
      for (; i < sL; i++) {
        if (i == 0) {
          returnS += str.charAt(i).toUpperCase();
        } else if (str.charAt(i) === str.charAt(i).toUpperCase()) {
          returnS += " " + str.charAt(i);
        } else {
          returnS += str.charAt(i);
        }
      }
      return returnS;
    },
    checkImg(img) {
      if (typeof img == "undefined") return;
      if (img.includes("data:image")) {
        return img;
      } else {
        return (
          this.$store.state.serverURL + "/artwork/" + img + "?" + Date.now()
        );
      }
    },
    getData: function () {
      this.loading = true;
      axios // read all artworks
        .get("/artwork/" + this.$store.state.user._id)
        .then((response) => {
          this.artworkList = response.data.map((a) => {
            a.product = this.productText(a);
            return a;
          });
          this.artwork =
            Object.keys(this.artwork).length > 0
              ? this.artwork
              : this.displayedArtwork[0] || {};
          this.activeClass = this.artwork._id;
          this.loading = false;
        })
        .catch(function (error) {
          alert(error);
        });
    },
    selectArtwork(id) {
      this.artwork = this.artworkList.find((a) => a._id == id);
      this.activeClass = id;
    },
    change(code) {
      this.activeClass2 = code;
    },
    createProduct() {
      if (isNaN(this.product.quantity) || this.product.quantity < 1) {
        this.$message({
          type: "error",
          message: "Enter quantity!",
        });
        return;
      }
      this.product.rid = this.$route.params.rid;
      this.product.artwork = this.artwork;
      axios
        .post("/roomtype/" + this.$route.params.rid + "/product", {
          product: this.product,
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.$router.push({ path: "/roomtype/" + this.$route.params.rid });
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
          }
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  },

  computed: {
    filtered_artwork: function () {
      var a = this.artworkList.filter((artwork) => {
        return artwork.name
          .toLowerCase()
          .includes(this.artwork_query.toLowerCase());
      });
      return this.sortArrayOfObjects(a, this.sortKey, this.reverseSort);
    },
    displayedArtwork() {
      return this.paginate(this.filtered_artwork);
    },
  },
  watch: {
    filtered_artwork(newItems) {
      this.set_pages(newItems);
    },
  },
};
</script>

<style>
</style>
